import React from "react";
import NavBar from "../../components/Navbar";
// import NavBar from "../../components/Navbar";

const Header = () => {
  return <NavBar />;
};

export default Header;
